module.exports = __webpack_public_path__ + "static/media/iep-ui-design07-thumb.bafe6507.png";